/**
 * Brand mark.
 *
 * The real mark, traced to vector from the approved splash artwork and
 * rendered to a bitmap by `scripts/generate-icons.sh`. It is the circular
 * badge rather than the bare mark because the plant and figure are white:
 * on any light surface the bare mark would lose half of itself, so the green
 * field travels with it.
 *
 * The bitmap is 192px for a mark drawn at 32pt, which stays crisp to 3x.
 */

import { memo } from 'react';
import { Image, StyleSheet } from 'react-native';

const BADGE = require('../../../assets/brand/logo-badge.png');

/** The line under the name, as the brand badge itself reads it. */
export const TAGLINE = 'A MEAL - A SMILE - A BLESSING';

/**
 * The tagline (in either language) with each phrase held together, so a
 * narrow screen breaks it at a dash — "A MEAL - A SMILE -" over "A BLESSING"
 * — and never leaves a lone "A" at the end of a line.
 */
export const unbrokenPhrases = (tagline: string): string =>
  tagline
    .split(' - ')
    .map((phrase) => phrase.replace(/ /g, '\u00a0'))
    .join(' - ');

export const Logo = memo(function Logo({ size = 32 }: { size?: number }) {
  return (
    <Image
      source={BADGE}
      // A small app icon: its square, with the corners an icon has.
      style={[styles.badge, { width: size, height: size, borderRadius: Math.round(size * 0.22) }]}
      resizeMode="contain"
      accessibilityRole="image"
      accessibilityIgnoresInvertColors
      accessibilityLabel="Meal4ALL"
      testID="brand-logo"
    />
  );
});

const styles = StyleSheet.create({
  badge: {
    overflow: 'hidden',
  },
});
